<style lang="less" scoped>
.title-div {
    font-weight: 600;
    margin: 20px 0 10px;
    font-size: 26px;
    // flex-grow: 1;
    color: #000;
}

.history {
    font-size: 14px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: #4182eb;
    line-height: 20px;
    height: 25px;
    margin-top: 35px;
    margin-left: 15px;
}

.custInfo_container {
    width: 100%;
    margin: 20px 10px;
    font-size: 14px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    display: flex;

    .cust-item {
        width: 25%;
    }
}

.el-col {
    font-size: 14px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    margin: 10px 0;

    >div:first-of-type {
        // width: 120px;
        text-align: left;
        font-size: 14px;
        font-weight: 400;
    }

    >div:last-of-type {
        font-size: 14px;
        min-width: 160px;
        text-align: right;
    }
}

// .cust-detail-item {
//   // t-w
// }
.page-action-btns {
    margin-bottom: 10px;
}

.cust-mes {
    margin: 0px 0px 14px 18px;
}

.top-title-div {
    font-size: 15px;
    margin-left: 10px;
}

.red-tip {
    color: #f56c6c;
    font-size: 12px;
    margin-left: 100px;
}

.detail-btn {
    height: 32px;
    margin-left: 45px;
    margin-top: 10px;
}

.account_item {
    width: 237px;
    height: 101px;
    background: #4182eb;
    border-radius: 22px;
    color: #fff;
    display: flex;
    align-items: center;
    padding: 10px 20px;
    margin-right: 50px;

    .img_con {
        width: 61px;
        height: 61px;
        background: #ffffff;
        border-radius: 50%;
        line-height: 75px;
        text-align: center;
    }

    .amount_con {
        flex-grow: 1;
        font-size: 12px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: #ffffff;
        text-align: right;
    }

    .amount_con :last-child {
        font-size: 26px;
        font-weight: 500;
    }
}
</style>

<template>
    <div class="detail-content-div">
        <div class="flex" style="margin-top: 20px;">
            <div class="account_item">
                <div class="img_con">
                    <img src="../../assets/detail/integral.png" alt="" />
                </div>
                <div class="amount_con">
                    <p>累计收益（元）</p>
                    <p>{{ detailForm.totalProfit }}</p>
                </div>
            </div>
            <div class="account_item">
                <div class="img_con">
                    <img src="../../assets/detail/integral.png" alt="" />
                </div>
                <div class="amount_con">
                    <p>可提现余额（元）</p>
                    <p>{{ detailForm.withdrawableAmount }}</p>
                </div>
            </div>
            <div class="account_item">
                <div class="img_con">
                    <img src="../../assets/detail/gain.png" alt="" />
                </div>
                <div class="amount_con">
                    <p>待入账金额（元）</p>
                    <p>{{ detailForm.pendingAmount }}</p>
                </div>
            </div>
            <div class="account_item">
                <div class="img_con">
                    <img src="../../assets/detail/spend.png" alt="" />
                </div>
                <div class="amount_con">
                    <p>已提现收益（元）</p>
                    <p>{{ detailForm.withdrawnAmount }}</p>
                </div>
            </div>
        </div>
        <div class="flex">
            <div class="title-div">提现记录</div>
        </div>
        <el-table class="el-table" :data="tableData" border style="width: 100%;margin:20px auto"
            :cell-style="{ 'text-align': 'center' }">
            <el-table-column prop="reqSeqId" label="提现流水号" />
            <el-table-column prop="cardNo" label="提现账号" />
            <el-table-column prop="cashAmt" label="提现金额（元）" />
            <el-table-column prop="transStatName" label="提现状态" />
            <el-table-column prop="intoAcctDateTypeName" label="到账日期类型" />
            <el-table-column prop="bankName" label="提现渠道" />
            <el-table-column prop="reqDate" label="提现申请时间" />
            <el-table-column prop="finishedTime" label="提现到账时间" />
        </el-table>
        <!-- 分页 -->
        <div class="list-pagination">
            <ZD-pagination :pagination="pagination" v-on:pageUpdate="getData"></ZD-pagination>
        </div>
        <div class="flex-r-end">
            <button class="common-empty-button" @click="back()">返 回</button>
        </div>
    </div>
</template>

<script>
import pageConfig from '../operationConfiguration/couponManagement/couponAllocation/page-config'
export default {
    data() {
        return {
            pageConfig: pageConfig, // 页面配置
            tableData: [], // 表格数据
            pagination: pageConfig.pagination,
            // 默认值设置
            custInfo: {},
            detailForm: {},
            queryInfo: {}, // 默认内容
        };
    },
    methods: {

        init() {
            let _ = this;
            if (_.$store.state.custObj) {
                _.custInfo = _.$store.state.custObj;

                _.getData(_.pagination, true)
            }
        },
        // 获取表格数据
        getData(pagination, reload = false) {
            let _ = this;
            _.$U.showLoading(_);
            _.queryInfo.pageNum = pagination.current - 1;
            if (reload) {
                _.pagination.current = 1;
                _.queryInfo.pageNum = 0;
            }
            _.queryInfo.pageSize = pagination.pageSize;
            _.queryInfo.custNo = _.custInfo.custNo;
            _.$U.showLoading(_);
            // 列表数据
            _.$H.post(_, _.$A.cust.getWithdrawLog, _.queryInfo).then((res) => {
                _.tableData = res.data.data.content || [];
                _.pagination.total = res.data.data.totalElements || 0;
                _.$U.hideLoading(_);
            });

            // 统计数据
            _.$H.post(_, _.$A.cust.getWithdraw, _.queryInfo).then((res) => {
                _.detailForm = res.data.data || {}
            })
        },
        resetQuery() {
            this.queryInfo = {
                searchKey: undefined,
            };
            this.getListData(this.pagination, true);
        },
        back() {
            this.$router.push({
                name: "custList",
            });
        },
    },
    mounted() {
        this.init();
    },
};
</script>
